/* eslint-disable @typescript-eslint/no-explicit-any, react-hooks/rules-of-hooks*/

import { PillGroup, PillGroupProps } from "@/components"
import { ConnectForm, ControlledComponentProps } from "@/components/Controlled"
import React from "react"
import { useController } from "react-hook-form"

export const PillGroupControl = ({ name, data, ...props }: ControlledComponentProps<PillGroupProps<any>>) => (
    <ConnectForm>
        {({ control }) => {
            const { field } = useController({ name, control })
            // @ts-expect-error
            return <PillGroup {...props} {...field} onChange={field.onChange} data={field.value} />
        }}
    </ConnectForm>
)
